import * as React from 'react';
import classnames from 'classnames';
import { Tooltip } from '@grandvisionhq/common';

const FormControlFieldWrapper = ({ className , label , required , hideAsteriskSign , tooltip , id , optionalText , errorMessageId , errorMessage , displayError , children ,  })=>/*#__PURE__*/ React.createElement("label", {
        className: classnames('form-control', className)
    }, label && /*#__PURE__*/ React.createElement("span", {
        className: "form-control__label"
    }, label, required && !hideAsteriskSign && /*#__PURE__*/ React.createElement("span", {
        className: "form-control__asterisk"
    }, "*"), tooltip && /*#__PURE__*/ React.createElement(Tooltip, {
        message: tooltip,
        id: id
    })), !required && optionalText && /*#__PURE__*/ React.createElement("small", {
        className: "form-control__optional-tag"
    }, optionalText), /*#__PURE__*/ React.createElement("div", {
        className: "form-control__wrapper"
    }, children), errorMessage && displayError && /*#__PURE__*/ React.createElement("span", {
        id: errorMessageId,
        className: "form-control__error"
    }, errorMessage))
;

export { FormControlFieldWrapper as default };
//# sourceMappingURL=FormControlWrapper.js.map
